export enum WorkflowStatusItemEnum {
  SendingFile = 1,
  FileReceived = 2,
  CopyingFileToOutput = 3,
  MovingFileToProcessDirectory = 4,
  StartingFileExtraction = 5,
  SuccessfullyExtractedFile = 6,
  StartingInformationGrouping = 7,
  FinishingInformationGrouping = 8,
  CreatingValidation = 9,
  ProcessingFile = 10,
  ProcessedFile = 11,
  ValidatingDocuments = 12,
  ValidationCompleted = 13,
}
